/**
 * Created by lucac 
 */
import { Injectable } from '@angular/core';
import { ConfProxy, HttpObservable } from 'common';
import { IProtocolTableXSpsCodeKey } from '../interfaces/protocol.table';

@Injectable({ providedIn: 'root' })
  export class ProtocolTableProxy {

	constructor(private confHttp:ConfProxy) {
	}

	public getProtocolTableXSpsCodeKey():HttpObservable<IProtocolTableXSpsCodeKey> {
		return this.confHttp.get("ProtocolTable", "GetProtocolTableXSpsCodeKey");
	}

}
